/* eslint-disable @ms/forbid-file-names */
import { CurrentNetworkContext } from '@ms/yammer-data/dist/state/types';

import { basenameForWebApp } from '.';

export type GetBaseUrl = (currentNetworkContext?: CurrentNetworkContext) => string;

export const getBaseUrl: GetBaseUrl = (currentNetworkContext) => {
  const protocol = window.location.protocol;
  const baseUrl = `${window.location.host}${basenameForWebApp}`;

  if (currentNetworkContext && currentNetworkContext.networkPath) {
    return `${protocol}//${baseUrl}/${currentNetworkContext.networkPath}`;
  }

  return `${protocol}//${baseUrl}`;
};
